import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import RichContent from '../../uielements/RichContent/richContent'
import { useTranslation } from 'react-i18next'
import ParallaxButton from '../../uielements/ParallaxButton'
import { screenSizes } from '../../lib/constants'
import { Box } from '@chakra-ui/react'
import InnerTitle from '../../uielements/InnerTitle'
import { theme } from '../../theme/theme'

const BgImage = styled.div`
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    height: 90vh;
    background-image: url('${(props) => props.bgImage}');
`

const BgImageShadow = styled.div`
    background-color: rgba(0, 0, 0, 0.55);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
`

const Content = styled.div`
    position: relative;
    color: #fff;
    max-width: 50vw;
`

const ParallaxImage = (props) => {
    const { i18n, t } = useTranslation()

    return (
        <BgImage {...props}>
            <BgImageShadow />
            <Box
                position={'absolute'}
                left={['30px', '30px', '20vw']}
                top={['20vh', '20vh', '20vw']}
            >
                <Box>
                    <Box maxW={['80vw', '80vw', '50vw']}>
                        <InnerTitle title={props.title} mainColor={theme.white} secColor={theme.white} />
                    </Box>
                    <Box color={'#fff'} maxW={['80vw', '80vw', '50vw']}>
                        <RichContent body={props.excerpt} locale={i18n.language} />
                    </Box>
                    <ParallaxButton textStyle="uppercase" link={props.slug}>
                        {t('read-more-no-tone')}
                    </ParallaxButton>
                </Box>
            </Box>

        </BgImage>
    )
}

ParallaxImage.propTypes = {
    bgImage: PropTypes.string,
    title: PropTypes.string,
    excerpt: PropTypes.object,
    slug: PropTypes.string,
}

ParallaxImage.defaultProps = {
    bgImage: 'https://via.placeholder.com/1920x1080',
    title: 'Some title',
    slug: 'some-slug',
}

export default ParallaxImage
